import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { Box, TextField, Button, Typography } from "@mui/material";

import { putGlobalIaac } from "../store/actions";
import { orderSubscriptions } from "./GlobalIaaC";

const READ_ONLY_PLANS = ["Enterprise", "AWS Marketplace"];

const EditGlobalIaaC = (props) => {
  const { subscriptions } = props.iaac;
  const [iaacSubscriptionData, setIaacSubscriptionData] = useState(subscriptions);

  useEffect(() => {
    if (props.iaac?.subscriptions) {
      setIaacSubscriptionData(props.iaac.subscriptions);
    }
  }, [props.iaac]);

  const handleIaacModelChange = (e, iaacParameter, plan) => {
    const updatedData = [...iaacSubscriptionData];
    const targetParameterRow = updatedData.find((row) => row.subscription === plan);
    if (!targetParameterRow) {
      return;
    }
    targetParameterRow[iaacParameter] = parseInt(e.target.value);
    setIaacSubscriptionData(updatedData);
  };

  const handleUpdateGlobalIaac = (e) => {
    e.preventDefault();
    const updateGlobalIaac = {
      subscriptions: iaacSubscriptionData,
    };
    props.putGlobalIaac(updateGlobalIaac);
  };

  const editableSubscriptions = orderSubscriptions(iaacSubscriptionData);

  return (
    <Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(5, 1fr)",
          },
          gap: 2,
          mt: 1,
        }}
      >
        {editableSubscriptions.map((plan) => {
          const isReadOnly = READ_ONLY_PLANS.includes(plan.subscription);
          const limitValue = plan.limit === -1 ? "Unlimited" : plan.limit;

          return (
          <Box
            key={plan.subscription}
            sx={{
              p: 2,
              border: "1px solid #e5eaf2",
              borderRadius: "8px",
              backgroundColor: isReadOnly ? "#f3f4f6" : "#fafbfd",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ color: isReadOnly ? "#6b7280" : "#193a6f", fontWeight: 700, mb: 1.5 }}
            >
              {plan.subscription}
            </Typography>
            <TextField
              label="Price"
              variant="outlined"
              size="small"
              type="number"
              fullWidth
              value={plan.price}
              disabled={isReadOnly}
              InputProps={{ readOnly: isReadOnly }}
              onChange={(e) => handleIaacModelChange(e, "price", plan.subscription)}
              sx={{ mb: 1.5 }}
            />
            <TextField
              label="Limit"
              variant="outlined"
              size="small"
              type={plan.limit === -1 ? "text" : "number"}
              fullWidth
              value={limitValue}
              disabled={isReadOnly}
              InputProps={{ readOnly: isReadOnly }}
              onChange={(e) => handleIaacModelChange(e, "limit", plan.subscription)}
              sx={{ mb: 0 }}
            />
          </Box>
          );
        })}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Button
          type="submit"
          variant="contained"
          disabled={props.isUpdatingGlobalIaac}
          onClick={handleUpdateGlobalIaac}
        >
          Update
        </Button>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  const {
    isUpdatingGlobalIaac,
    updateGlobalIaacMessage,
    updateGlobalIaacError,
  } = state.globalIaac;
  return {
    isUpdatingGlobalIaac,
    updateGlobalIaacMessage,
    updateGlobalIaacError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    putGlobalIaac: (globalIaac) => {
      dispatch(putGlobalIaac(globalIaac));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditGlobalIaaC);
